import classNames from 'classnames'
import React from 'react'
import { Text } from '.'
import { FormattedMessage } from 'react-intl'

type LegalTextProps = {
  className?: string
}

export function LegalText({ className }: LegalTextProps) {
  return (
    <Text.SmallDetail
      className={classNames('line-height-large shade-20', className)}
      style={{ marginBottom: '0' }}
    >
      <FormattedMessage
        id="boarding.createOrganization.legalText"
        defaultMessage="By continuing, you're agreeing to our <terms>terms</terms> and <privacy>privacy policy</privacy>."
        values={{
          terms: (text: React.ReactNode) => (
            <a
              className="underline shade-20"
              rel="noopener noreferrer"
              target="_blank"
              href="https://slite.com/terms"
            >
              {text}
            </a>
          ),
          privacy: (text: React.ReactNode) => (
            <a
              className="shade-20 underline"
              rel="noopener noreferrer"
              href="https://slite.com/privacy"
              target="_blank"
            >
              {text}
            </a>
          ),
        }}
      />
    </Text.SmallDetail>
  )
}
